import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = {
  class: "trezo-card-content",
  id: "customerReviewsSlides"
}
const _hoisted_6 = { class: "sm:flex items-center justify-between mb-[10px] sm:mb-[12px]" }
const _hoisted_7 = { class: "flex items-center gap-[12px]" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "block sm:text-[15px] text-black dark:text-white font-semibold" }
const _hoisted_10 = { class: "block text-gray-500 dark:text-gray-400" }
const _hoisted_11 = { class: "flex items-center gap-[3px] mt-[15px] sm:mt-0" }
const _hoisted_12 = { class: "md:max-w-[365px] text-gray-700 dark:text-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Customer Reviews")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["trezo-card-dropdown-btn inline-block transition-all text-[26px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500", {
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }]),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "ri-more-fill" }, null, -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Day </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Week </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Month </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Year </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Swiper, {
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        pagination: { el: '.swiper-pagination', clickable: true },
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 1,
          },
          1440: {
            slidesPerView: 2,
          },
        },
        modules: _ctx.modules,
        class: "mySwiper2"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertys, (property) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: property.id,
              class: "bg-gray-50 dark:bg-[#0a0e19] rounded-md py-[20px] md:py-[25px] px-[20px]"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: property.image,
                      class: "w-[45px] rounded-full",
                      alt: `${property.name}-image`
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(property.name), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(property.time), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createElementVNode("i", {
                        key: star,
                        class: _normalizeClass({
                  'ri-star-fill text-orange-500':
                    star <= Math.floor(property.rating),
                  'ri-star-half-fill text-orange-500':
                    star === Math.ceil(property.rating) &&
                    !Number.isInteger(property.rating),
                  'ri-star-line text-orange-500': star > property.rating,
                })
                      }, null, 2)
                    }), 64))
                  ])
                ]),
                _createElementVNode("p", _hoisted_12, _toDisplayString(property.desc), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
        ]),
        _: 1,
        __: [4]
      }, 8, ["modules"])
    ])
  ]))
}